import mapActions from './mapActions';

export default mapActions('tools');